import type { DashboardBuilderState } from './types';
import { DASHBOARD_BUILDER_SCHEMA_VERSION } from './types';
import { DEFAULT_DASHBOARD_HEADER_CHROME, DEFAULT_HEADER_WIDGETS } from './dashboardHeaderDefaults';

export const defaultDashboardBuilderState = (): DashboardBuilderState => ({
  version: DASHBOARD_BUILDER_SCHEMA_VERSION,
  header: { ...DEFAULT_DASHBOARD_HEADER_CHROME },
  headerWidgets: [...DEFAULT_HEADER_WIDGETS],
  layout: [],
  widgets: {},
});
